import { connect } from "react-redux";
import {
  PageBookFiltered,
  PageBookFilteredWeb,
  PageBookFound,
} from "senac-components";
import { commonSlice, contentSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import {
  PageBookFilteredPropsDispach,
  PageBookFilteredState,
} from "senac-components/dist/pages/Mobile/PageBookFiltered";
import { Wrapper, WrapperStateProps, WrapperDispatchProps } from "./Wrapper";

import { loadAndOpenContent, loadMoreFromActiveContentFilter, showContentDetail } from "../store/reducers/contentSlice";
import {
  Content,
  MenuOptions,
  PageHeaderOptionItem,
} from "senac-components/dist/pages/Mobile/PageInterfaces";
import { PageBookFilteredWebDispach, PageBookFilteredWebState } from "senac-components/dist/pages/Web/PageBookFiltered";
import { filterContent } from "../store/reducers/common";

const mapState = (state: RootState, props: any) => {
  const authenticatedUser = state.userState.user != undefined;
  var allContent = state.contentState.allContents;
  var contents: Content[] | undefined = undefined;

  if (state.contentState.contentFromFilter) {
    contents = state.contentState.contentFromFilter
      .map((p) => allContent.find((c) => c.uid == p))
      .filter((p) => p != undefined) as Content[];
  }


  let result: PageBookFilteredState & WrapperStateProps & PageBookFilteredWebState = {
    activeCategory: state.contentState.activeFilter?.category,
    categories: state.contentState.activeFilter?.category?.childs,
    contents: contents,
    authenticatedUser: authenticatedUser,
    element: window.innerWidth < 1024 ? PageBookFiltered : PageBookFilteredWeb,
    allCategories: state.contentState.categories,
    fetching: state.contentState.activeFilter?.processing,
    haveMoreContent: Boolean(state.contentState.activeFilter?.customQuery)
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch, props: any) => {
  const result: PageBookFilteredPropsDispach & WrapperDispatchProps & Partial<PageBookFilteredWebDispach> = {
    onSelectedCategory: (category) => dispatch(contentSlice.actions.contentFilter({ category: category })),
    onSelectedContent: (content) => dispatch(showContentDetail(content.uid)),
    onClickContentDetail: (content) => dispatch(showContentDetail(content.uid)),
    onClickContent: (content: Content) => dispatch(loadAndOpenContent(content.uid)),
    onChangeParams: (params: any) =>{
      dispatch(
        contentSlice.actions.contentFilter({
          category: { uid: params.categoryUid },
        })
      )},
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onSelectedHeaderMenuOption: (option: PageHeaderOptionItem) => dispatch(commonSlice.actions.goToPageOption(option)),
    onSelectedNavigationPageOption: (option: MenuOptions) => dispatch(commonSlice.actions.goToPage(option)),
    onClickHelp: () => dispatch(commonSlice.actions.helpPage()),
    onClickLogin: () => dispatch(commonSlice.actions.loginOptionsPage()),
    onChangeFilter: (filter) => {
      if (filter.query == undefined) return;
      dispatch(filterContent({ query: filter.query }));
    },
    onLoadMore: () => dispatch(loadMoreFromActiveContentFilter()),
  };

  return result;
};

const WPageBookFiltered = connect(mapState, mapDispatch)(Wrapper);

export { WPageBookFiltered };
